import React, { memo } from "react";
import { Box, Typography } from "@mui/material";
import { bankExtractionCopy } from "@investorRequest/constants/bankExtractionCopy";

const BankExtractionEditedBadge = () => (
  <Box
    component="span"
    data-testid="bank-extraction-edited-badge"
    aria-label={bankExtractionCopy.editedBadge}
    sx={{
      bgcolor: "grey.200",
      color: "text.primary",
      borderRadius: 1,
      px: 1,
      py: 0.25,
      fontSize: 12,
      lineHeight: 1.4,
      ml: 1,
      whiteSpace: "nowrap",
    }}
  >
    <Typography component="span" variant="caption">
      {bankExtractionCopy.editedBadge}
    </Typography>
  </Box>
);

export default memo(BankExtractionEditedBadge);
